import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SuccessResponse } from 'src/app/model/success-response.model';
import { environment } from 'src/environments/environment';
import {
  BalancesOverviewResponse,
  ContactPayload,
  InviteContactPayload,
  RecentTransactionsResponse,
  SearchedContact,
} from './state/dashboard.state';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private apiServerHost: string = environment.apiServerHost;
  constructor(private httpClient: HttpClient) {}

  getSearchContacts(
    searchTerm: string,
    userId: number,
  ): Observable<SearchedContact[]> {
    return this.httpClient.get<SearchedContact[]>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/contacts/search-contacts?efilaQuery=${searchTerm}`,
    );
  }

  addChosenContact(payload: ContactPayload): Observable<SuccessResponse> {
    return this.httpClient.post<SuccessResponse>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${payload.userId}/contacts/add-contact`,
      payload,
    );
  }

  getBalancesOverview(userId: number): Observable<BalancesOverviewResponse> {
    return this.httpClient.get<BalancesOverviewResponse>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/balances-overview`,
    );
  }

  getRecentTransactions(
    userId: number,
    selectedYear: number,
  ): Observable<RecentTransactionsResponse> {
    return this.httpClient.get<RecentTransactionsResponse>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/recent-transactions?selectedYear=${selectedYear}`,
    );
  }

  inviteChosenContact(
    userId: number,
    searchedContact: string,
  ): Observable<SuccessResponse> {
    const payload: InviteContactPayload = {
      userId,
      status: null,
      contact: {
        contactUserId: null,
        emailId: searchedContact,
      },
    };
    return this.httpClient.post<SuccessResponse>(
      `${this.apiServerHost}/cm-services/api/v1/account-service/users/${userId}/contacts/invite-contact`,
      payload,
    );
  }
}
